import { HTMLAttributes, ReactNode } from "react"
import { twMerge } from "tailwind-merge"


interface RootProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
}

export function Root({ children, ...rest }: RootProps) {
    return (
        <div className={twMerge("tw-w-auto tw-justify-center", rest.className)} {...rest}>
            {children}
        </div>
    )
}
